<template>
  <p v-cleaned="descriptionHtml" />
  <form @submit.prevent="() => null">
    <input v-model="email" type="email" placeholder="Email" />
    <ButtonBase
      type="submit"
      theme="secondary"
      stroke="n"
      class="button"
      :disabled="!emailValid"
      rounded
      @click.prevent="handleClickSubmit"
    >
      {{ labelSubmit }}
    </ButtonBase>
    <ButtonUnderline v-if="cancel" @click.prevent="handleClickCancel">
      {{ labelCancel }}
    </ButtonUnderline>
  </form>
</template>
<script lang="ts" setup>
import DialogUserShareEmailComplete from '~/components/dialog/user/DialogUserShareEmailComplete.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';
interface Props {
  cancel?: boolean;
  labelCancel?: string;
  labelSubmit?: string;
  descriptionHtml: string;
  descriptionSendMailCompleteHtml: string;
  defaultEmail?: string;
  data: any;
  sourceLocation: string;
  appEventShare: UseAppEventShare;
  forced: boolean;
}

const props = defineProps({
  cancel: { type: Boolean, default: false },
  labelCancel: null,
  labelSubmit: { default: 'Envoyer' },
  descriptionHtml: null,
  descriptionSendMailCompleteHtml: null,
  defaultEmail: { default: '' },
  data: null,
  sourceLocation: null,
  appEventShare: null,
  forced: { type: Boolean }
});

const attrs = useAttrs();

const emit = defineEmits(["cancel"]);

const dialog = useDialogStore();

const email = defineModel<string>({ default: '' });

email.value = props.defaultEmail;

const emailValid = computed(() => {
  const pattern =
    '^[a-zA-Z0-9+_%\\-+]{1,256}(?:.[a-zA-Z0-9+_%-+]{1,256})*@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9-]{0,25})+[a-zA-Z0-9]$';
  return new RegExp(pattern).test(email.value);
});

const submit = async () => {
  if (!emailValid.value) return;
  const { error, status } = await useApiFetch(URI.SendParentEmail, {
    method: 'POST',
    body: {
      email: email.value,
      template: 'solo',
      sourceLocation: props.sourceLocation,
      data: props.data,
    },
  });

  if (status >= 400) {
    dialog.open(DialogError, {
      ...attrs,
      level: DialogLevel.Info,
      title: 'Oups !',
      label: error.response?._data?.summary || "une erreur s'est produite",
    });
  } else {
    props.appEventShare.sentParentInfo();
    dialog.close();

    dialog.open(DialogUserShareEmailComplete, {
      ...attrs,
      position: 'center',
      level: DialogLevel.Info,
      descriptionHtml: props.descriptionSendMailCompleteHtml,
      closeTimer: 4000,
    });
  }
};

watchEffect(() => (email.value = email.value.toLowerCase()));

const handleClickSubmit = () => {
  submit();
};

const handleClickCancel = () => {
  emit('cancel');
};
</script>
<style lang="scss" scoped>
.dialog {
  max-width: 45rem;

  :deep(.content) {
    gap: var(--gap_l);
  }
}

h3 {
  @include font('m', 800, 'secondary');

  text-align: center;
}

p {
  @include font('n', 400, 'secondary');

  text-align: center;
}

// .image {
//   width: 100%;
//   height: 16.3rem;
//   margin-bottom: var(--gap_xl);
//   background-image: url('~/assets/images/exercise/exercise-mail.svg');
//   background-repeat: no-repeat;
//   background-position: center;
//   background-size: contain;
// }

.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
  align-items: center;
}

form {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  align-items: center;
  width: 100%;
}

input {
  width: 100%;
  padding: var(--gap_s) var(--gap_m);
  transition: border 200ms $ease-out-quad;
  border-radius: var(--border_radius);
  border-color: var(--color_secondary_lighter);
  background-color: var(--color_neutral_25);
  color: var(--color_neutral_900);
  font-size: var(--font_size_m);
  text-align: center;
  @include stroke('m', 'm');
  &:focus {
    border-color: var(--color_secondary);
  }
  &::placeholder {
    color: var(--color_neutral_400);
  }
}

.button {
  width: 100%;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
